import type { RouteObject } from 'react-router';
import { handle } from '@/app/router/handle';

/** /payments */
export const paymentsRoutes: RouteObject = {
  path: 'payments',
  handle: handle('payments'),
  lazy: () => import('./PaymentsPage').then((m) => ({ Component: m.PaymentsPage })),
};
